import { render, staticRenderFns } from "./KVideoArea.vue?vue&type=template&id=4b5724b9&scoped=true&"
import script from "./KVideoArea.vue?vue&type=script&lang=js&"
export * from "./KVideoArea.vue?vue&type=script&lang=js&"
import style0 from "./KVideoArea.vue?vue&type=style&index=0&id=4b5724b9&scoped=true&lang=css&"
import style1 from "./KVideoArea.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5724b9",
  null
  
)

export default component.exports